var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "h-[88px] lg:h-[99px]" }),
    _vm._v(" "),
    _c("div", { staticClass: "filter mb-32 bg-black" }, [
      _c("div", { staticClass: "container py-[20px]" }, [
        _c(
          "div",
          {
            staticClass: "w-full lg:flex lg:flex-row gap-24",
            class: { hidden: !_vm.open, "flex flex-col": _vm.open }
          },
          [
            _vm.filters && _vm.filters.show_sale_or_let
              ? _c(
                  "div",
                  {
                    staticClass:
                      "h-[59px] border border-white text-white flex flex-row items-center rounded-2 mr-auto lg:mr-8"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "px-[20px] h-full flex items-center font-bold cursor-pointer hover:bg-white hover:text-black transition-colors rounded-l-2",
                        class: {
                          "bg-white text-black":
                            _vm.params.sale_or_let === "sale"
                        },
                        on: {
                          click: function($event) {
                            _vm.params.sale_or_let = "sale"
                            _vm.handleFilterChanged()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        KOPEN\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "px-[20px] h-full flex items-center font-bold cursor-pointer hover:bg-white hover:text-black transition-colors rounded-r-2",
                        class: {
                          "bg-white text-black":
                            _vm.params.sale_or_let === "let"
                        },
                        on: {
                          click: function($event) {
                            _vm.params.sale_or_let = "let"
                            _vm.handleFilterChanged()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        HUREN\n                    "
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.filters && _vm.filters.show_location
              ? _c("el-select", {
                  ref: "locationSelect",
                  staticClass: "w-full lg:w-auto lg:flex-1 max-w-[350px]",
                  attrs: {
                    typeahead: true,
                    sale_or_let: _vm.params.sale_or_let,
                    options: _vm.cityOptions,
                    multiple: true,
                    grouped: true,
                    name: "location",
                    theme: "dark"
                  },
                  on: { input: _vm.handleFilterChanged },
                  model: {
                    value: _vm.params.zips,
                    callback: function($$v) {
                      _vm.$set(_vm.params, "zips", $$v)
                    },
                    expression: "params.zips"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.filters && _vm.filters.show_type
              ? _c("el-select", {
                  ref: "typeSelect",
                  staticClass: "w-full lg:w-auto",
                  attrs: {
                    "select-min-width": "min-w-[160px]",
                    options: _vm.typeOptions,
                    name: "type",
                    theme: "dark"
                  },
                  on: { input: _vm.handleFilterChanged },
                  model: {
                    value: _vm.params.type,
                    callback: function($$v) {
                      _vm.$set(_vm.params, "type", $$v)
                    },
                    expression: "params.type"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.filters && _vm.filters.show_bedrooms
              ? _c("el-select", {
                  ref: "bedroomSelect",
                  staticClass: "w-full lg:w-auto",
                  attrs: {
                    "select-min-width": "min-w-[160px]",
                    options: _vm.bedroomOptions,
                    name: "bedrooms",
                    theme: "dark"
                  },
                  on: { input: _vm.handleFilterChanged },
                  model: {
                    value: _vm.params.bedrooms,
                    callback: function($$v) {
                      _vm.$set(_vm.params, "bedrooms", $$v)
                    },
                    expression: "params.bedrooms"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.filters && _vm.filters.show_price
              ? _c("el-select", {
                  ref: "priceSelect",
                  staticClass: "w-full lg:w-auto",
                  attrs: {
                    "select-min-width": "min-w-[210px]",
                    options: _vm.priceOptions,
                    name: "price",
                    theme: "dark"
                  },
                  on: { input: _vm.handleFilterChanged },
                  model: {
                    value: _vm.params.price,
                    callback: function($$v) {
                      _vm.$set(_vm.params, "price", $$v)
                    },
                    expression: "params.price"
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.open
          ? _c(
              "a",
              {
                staticClass:
                  "mt-16 lg:mt-0 mb-8 text-15 bg-brand text-white uppercase font-semi block p-24 border border-brand text-center lg:hidden",
                attrs: { href: "javascript:void(0)" },
                on: { click: _vm.getMobileEstates }
              },
              [_vm._v("Filter resultaten")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "text-15 uppercase font-semi block p-24 border border-brand text-center lg:hidden text-white",
            on: {
              click: function($event) {
                _vm.open = !_vm.open
              }
            }
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.open ? "Filter sluiten" : "Filter resultaten") +
                "\n            "
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "container flex flex-col lg:flex-row items-center justify-between mb-32 gap-16"
      },
      [
        _c(
          "form-checkbox",
          {
            attrs: {
              name: "projects_only",
              "label-position": "rtl",
              "label-class":
                "!text-black !text-[16px] !font-regular !tracking-normal !leading-normal cursor-pointer",
              label: "Toon enkel nieuwbouwprojecten"
            },
            on: { input: _vm.handleFilterChanged },
            model: {
              value: _vm.params.is_unit,
              callback: function($$v) {
                _vm.$set(_vm.params, "is_unit", $$v)
              },
              expression: "params.is_unit"
            }
          },
          [
            _c("template", { slot: "label" }, [
              _vm._v("Toon enkel nieuwbouwprojecten")
            ])
          ],
          2
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "text-[20px]",
          domProps: { innerHTML: _vm._s(_vm.computedTitle) }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "estates grid grid-cols-1 lg:grid-cols-3 gap-32 container"
      },
      [
        _vm._l(_vm.estates, function(estate) {
          return _c("estate-card", {
            key: estate.id,
            class: { "lg:col-span-2": estate.is_project },
            attrs: {
              carousel: true,
              estate: estate,
              "alternative-style": !!estate.is_project
            }
          })
        }),
        _vm._v(" "),
        _vm.loading
          ? _c(
              "div",
              {
                staticClass:
                  "loading-holder col-span-3 flex items-center justify-center"
              },
              [_c("div", { staticClass: "circle-loader" })]
            )
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _vm.estates.length === 0
      ? _c("div", { staticClass: "text-center container" }, [
          _c("div", { staticClass: "text-32 font-bold mb-16" }, [
            _vm._v("Geen panden gevonden")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-20 text-gray-800" }, [
            _vm._v("Pas je zoekterm aan om meer resultaten te zien.")
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.pageData.current !== _vm.pageData.last
      ? _c(
          "div",
          {
            staticClass:
              "container flex items-center justify-items-center mt-24"
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "nav-btn bg-red text-white uppercase text-15 font-semi py-24 px-40 lg:inline-block mx-auto cursor-pointer duration-300 transition-transform transform-gpu hover:scale-110",
                on: { click: _vm.loadMore }
              },
              [_vm._v("Laad meer")]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }